export enum ProductDescriptionType {
    TEXT = 'text',
    IMAGE = 'image',
}
